"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSymbolsFullName = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 * 获取币种名称
 * @param symbols 如， [BTC, ...], 长度最多 100
 *
 * 文档: https://pionex.atlassian.net/wiki/spaces/backend/pages/532414529
 *
 * eg:
 *
 * 请求
 *
 * coins: [BTC, ...]
 *
 * 返回
 *
 * {
 *      full_names: {
 *           BTC: "Bitcoin",
 *          ....
 *      }
 * }
 *
 *
 */
function getSymbolsFullName(coins = []) {
    const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().quotation}/symbol/full_name`;
    return trade_utils_lib_1.Network.post({
        url,
        data: { symbols: coins },
    });
}
exports.getSymbolsFullName = getSymbolsFullName;
